import { BuildPlanPayload, Recipe, RecipeType } from '../pages/types';

type PlanOptionsPlanSizes = {
  plan_size: { id: string };
  unkibble_plan_size: { id: string };
};

// Mirrors snt-api RecipeType.main_type: a plan with any Fresh recipe is Fresh
export const getMainRecipeType = (recipes: Recipe[]): RecipeType => {
  if (recipes.some((recipe) => recipe.type === RecipeType.FRESH)) {
    return RecipeType.FRESH;
  }
  if (recipes.some((recipe) => recipe.type === RecipeType.AIRDRIED)) {
    return RecipeType.AIRDRIED;
  }
  return RecipeType.UNKIBBLE;
};

export const getRecommendedPlanSizeId = (
  planOptions: PlanOptionsPlanSizes,
  recipeType?: string
): string =>
  recipeType === RecipeType.UNKIBBLE || recipeType === RecipeType.AIRDRIED
    ? planOptions.unkibble_plan_size.id
    : planOptions.plan_size.id;

export const buildBuildPlanPayload = ({
  planSizeId,
  recipes,
  recipeIds,
  accountId,
  frequency,
}: {
  planSizeId: string;
  recipes?: Recipe[];
  recipeIds?: string[];
  accountId: string;
  frequency?: number | null;
}): BuildPlanPayload => {
  const ids = recipeIds ?? recipes?.map((recipe) => recipe.id) ?? [];
  const payload: BuildPlanPayload = {
    discounts: [],
    plan_size: planSizeId,
    recipes: ids,
    account_id: accountId,
  };
  if (frequency !== undefined && frequency !== null) {
    payload.frequency = frequency;
  }
  return payload;
};

// Mirrors snt-api PetPlan.replace_meal_product: legacy plans get no frequency (lowest available)
export const resolvePlanFrequency = ({
  flexFrequencySelection,
  hasSixWeekFrequency,
}: {
  flexFrequencySelection?: number | null;
  hasSixWeekFrequency?: boolean | null;
}): number | null => {
  if (flexFrequencySelection !== null && flexFrequencySelection !== undefined) {
    return flexFrequencySelection;
  }
  return hasSixWeekFrequency ? 6 : null;
};
